import { render } from "./footer-component.vue?vue&type=template&id=27784615"
import script from "./footer-component.vue?vue&type=script&lang=js"
export * from "./footer-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__